// extracted by mini-css-extract-plugin
export default {"banner":"LoginAsBanner_banner__43+F4","text":"LoginAsBanner_text__jlg1K","end":"LoginAsBanner_end__w3dxb"};